/* eslint-disable vars-on-top */

'use strict';

$(document).ready(function () {
  var pageLoad = false;
  var firstUrl = window.location.href;
  var variantOnLoad = getParam('colour');
  var variantId = getParam('variant');
  var variantLabelCheck = variantOnLoad.replace(/-/g, ' ');
  var variantLabel = capitalizeEachWord(variantLabelCheck);
  var json = document
    .querySelector('[data-product-gallery-images]')
    .innerHTML.replace(/,(?=[^,]+$)/, ''); // remove final comma (only occurs with incomplete variant metafield sets)
  var galleryImages = JSON.parse(json).products;
  var allFeaturedImagesFound = [];
  var allThumbnailImagesFound = [];
  var sliderInit = false;

  // Check & Strip Any Tracking Params Into Var
  var urlParts = firstUrl.split('?');
  var submittedParams = urlParts[1];
  var additionalParams = false;
  if (submittedParams) {
    var params = submittedParams.split('&');
    for (var i = 0; i < params.length; i++) {
      var param = params[i].split('=');
      if (isTrackingParam(param[0])) {
        additionalParams
          ? (additionalParams += '&' + params[i])
          : (additionalParams = params[i]);
      }
    }
  }

  // Check For Tracking Param
  function isTrackingParam(paramName) {
    switch (paramName) {
      case 'utm_source':
        return true;
      case 'utm_medium':
        return true;
      case 'utm_campaign':
        return true;
      case 'utm_content':
        return true;
      case 'bis_id':
        return true;
      default:
        return false;
    }
  }

  if (firstUrl.includes('?colour=')) {
    var inv;
    var variantFound;
    var materialCheck;
    var viewInHomeLink;
    var variantObjectSelected;
    var variantObject = JSON.parse($('.variants-json').text());

    $('.variant-input').each(function () {
      if ($(this).data('value') == variantOnLoad) {
        variantFound = $(this).find('label');
        viewInHomeLink = $(this).attr('data-view-in-home');
        // eslint-disable-next-line no-undef
        inv = inventories[$(this).data('section-id')][$(this).data('variant-id')];
      }
    });

    $(variantFound).prop('checked', true);
    $('.pt-product-view-in-home-link').attr('href', viewInHomeLink);

    $('.pt-product-title-colour').text(' | ' + variantLabel);

    $(variantObject).each(function () {
      if (
        $(this)[0].title.toLowerCase().replace(/\s+/g, '-') == variantOnLoad
      ) {
        variantObjectSelected = $(this);
      }
    });

    if (!variantObjectSelected) {
      variantObjectSelected = $(variantObject[0]);
    }

    $('.variant-input').each(function () {
      if (
        $(this).data('value') == variantObjectSelected[0].title.toLowerCase()
      ) {
        inv = inventories[$(this).data('section-id')][$(this).data('variant-id')];
      }
    });

    // if (variantObjectSelected[0].compare_at_price != null) {
    //   $('.pt-form-product-compare-price-container').show();
    //   $('.pt-form-product-price-compare').text(theme.Currency.formatMoney(variantObjectSelected[0].compare_at_price, theme.settings.moneyFormat));
    // } else {
    //   $('.pt-form-product-compare-price-container').hide();
    // }

    if (inv < 20) {
      $('.pt-form-product-inventory').text('Only ' + inv + ' left in stock!');
      if (variantObjectSelected[0].available) {
        $('.pt-form-product-inventory').show();
      }
    } else {
      $('.pt-form-product-inventory').hide();
    }

    if (!variantObjectSelected[0].name.toLowerCase().includes('swatch')) {
      // new process - loops through gallery json and loads image based on variant
      if (pageLoad) {
        if (sliderInit) return false;
        destroySliders();

        reloadGallery(galleryImages, $.trim(variantOnLoad.toLowerCase()));
      }
    }

    $('.product-single__variants option').each(function () {
      var colourNamesOne = $(this)
        .attr('data-colour-name')
        .toLowerCase()
        .replace(/\s+/g, '-');
      $(this).attr('selected', false);
      if (colourNamesOne == variantOnLoad) {
        $(this).attr('selected', true);
      }
    });

    $('.variant-input').each(function () {
      var colourNamesTwo = $(this)
        .attr('data-value')
        .toLowerCase()
        .replace(/\s+/g, '-');
      $(this).find('input').attr('checked', false);
      if (colourNamesTwo == variantOnLoad) {
        materialCheck = $(this).attr('data-material');
        $(this).find('input').attr('checked', true);
      }
    });

    $('.variant__label-info').find('span').text(variantLabel);
    $('.pt-product-information-material-type').text(materialCheck);

    // If Theme JS Is Already Loaded, Just Change Price
    if (window.theme && window.theme.loaded) {
      $(
        '[data-variant-id="' +
          variantObjectSelected[0].id +
          '"] .variant-radio-button'
      ).click();
      // Otherwise, Setup An Event Listener And Fire JS Price Change Once Theme JS Is Loaded
    } else {
      document.addEventListener('SwyftThemeJsLoaded', function (event) {
        var initialPrice = window.theme.Currency.formatMoney(
          variantObjectSelected[0].price,
          window.theme.settings.moneyFormat
        );
        if (initialPrice) {
          initialPrice = initialPrice.replace(/<[^>]*>?/gm, '');
          $('.pt-form-product-price').text(initialPrice);
        }
      });
    }

    // No Colour in URL
  } else {
    let variantObjectFirst = JSON.parse($('.variants-json').text());
    let variantObjectFirstSelected = [];
    let inv;

    if (variantId) {
      // variant in query string so loop through variant and get selected
      $.each(variantObjectFirst, function (i, value) {
        if (value.id == variantId) {
          variantObjectFirstSelected = $(variantObjectFirst[i]);
          return false;
        }
      });
    }

    // variant not found so used first one in list
    if (variantObjectFirstSelected.length == 0) {
      variantObjectFirstSelected = $(variantObjectFirst[0]);
    }

    // get inventory count from shopify
    $('.variant-input').each(function () {
      if (
        $(this).data('value') ==
        variantObjectFirstSelected[0].title.toLowerCase()
      ) {
        inv =
          inventories[$(this).data('section-id')][$(this).data('variant-id')];
      }
    });

    if (variantObjectFirstSelected[0].compare_at_price != null) {
      $('.pt-form-product-compare-price-container').show();
      $('.pt-form-product-price-compare span.strike-through').text(
        // eslint-disable-next-line no-undef
        theme.Currency.formatMoney(
          variantObjectFirstSelected[0].compare_at_price,
          theme.settings.moneyFormat
        )
      );
    } else {
      $('.pt-form-product-compare-price-container').hide();
    }

    // if (pageLoad) {
    //   var available = getVariantAvailabilityByProduct(variantObjectFirstSelected[0]);
    //   if (available) {
    //     $('.pt-product-notify-me-container').hide();
    //   } else {
    //     $('.pt-form-product-inventory').hide();
    //     $('.pt-form-add-to-cart-button').hide();
    //   }
    // }
  }

  $('.variant-input label').on('click', function () {
    // $(this).animate(
    //   {
    //     scrollTop: $('.pt-outer').offset().top
    //   },
    //   10
    // );

    // Set Select To Trigger Tracking
    $('select[name="id"]')
      .val($(this).parent().data('variant-id'))
      .trigger('change');

    var url = window.location.href;
    var initUrl = url.split('?');
    var base_url = initUrl[0];
    let new_url;

    var colour = $(this)
      .parent()
      .find('input')
      .attr('data-color-name');
    var colourName = $(this).parent().find('input').attr('data-color-name');
    if (colourName) colourName = colourName.toLowerCase().replace(/\s+/g, '-');
    var material = $(this).parent().attr('data-material');
    var viewInHome = $(this).parent().attr('data-view-in-home');

    if (colourName) {
      $('.pt-product-title-colour').text(' | ' + colour);

      // new process - loops through gallery json and loads images based on variant
      if (pageLoad) {
        if (sliderInit) return false;
        destroySliders();
        sliderInit = true;

        reloadGallery(galleryImages, $.trim(colourName.toLowerCase()));
      }

      $('#VariantColorLabel-0').text(colour);
      $('.pt-product-information-material-type').text(material);
      $('.pt-product-view-in-home-link').attr('href', viewInHome);

      if (url.includes('?colour=' + colourName)) {
        // console.log('Same One');
      } else {
        if (url.includes('?colour=')) {
          // console.log('New Colour');
          var currentVariant = getParam('colour');
          new_url = base_url + '?colour=' + colourName;
        } else {
          // console.log('No Colour');
          new_url = base_url + '?colour=' + colourName;
        }

        // Add Tracking Params
        if (additionalParams) {
          new_url += '&' + additionalParams;
        }

        // window.history.pushState({}, '', new_url);
      }
    }
  });

  if (!firstUrl.includes('?colour=')) {
    if (variantId != '') {
      $('.variant-input').each(function () {
        if ($(this).data('variant-id') == variantId) {
          $(this).find('label').click();
        }
      });
    } else {
      setTimeout(function () {
        $('#firstVariantOption').click();
      }, 2000);
    }
  }

  pageLoad = true;

  function getParam(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(window.location.search);
    return results === null
      ? ''
      : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }

  function capitalizeEachWord(str) {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }

  // loop through gallery json and add images to be shown to gallery in array and build in page
  function reloadGallery(galleryImages, variantTitle) {
    allFeaturedImagesFound = [];
    allThumbnailImagesFound = [];
    var imageArray = [];

    // Generate Image Array
    for (const key in galleryImages) {
      const title = $.trim(
        key.toLowerCase().split('image')[0]
        // eslint-disable-next-line eqeqeq
      ).replace(/\s+/g, '-');

      // remove everything after last dash
      var compare = title.substr(0, title.lastIndexOf('-'));
      if (compare == variantTitle) {
        // variant found so rebuild html
        const image = galleryImages[key];
        imageArray.push(image);
      }
    }

    // Loop Image Array & Load
    var imagesLoaded = 0;
    imageArray.forEach((image) => {
      // create external div
      var div = document.createElement('div');
      div.className = 'pt-featured-image-container';
      div.dataset.colour = variantTitle;

      // create featured img
      var featured = new Image();
      featured.addEventListener('load', () => {
        imagesLoaded++;
        if (imagesLoaded >= imageArray.length) {
          populateHTMLImages();
        }
      });

      // set srcset to prevent lazyload from reloading images
      const srcset = image.image_src + '&width=180 ' + image.image_src + '&width=360 ' + image.image_src + '&width=540 ' + image.image_src + '&width=720 '
                    + image.image_src + '&width=900 ' + image.image_src + '&width=1080 '+ image.image_src + '&width=1296 ' + image.image_src + '&width=1512 '
                    + image.image_src + '&width=1728 ' + image.image_src + '&width=2048 ';

      featured.src = image.image_src;
      featured.alt = image.image_alt;
      featured.dataset.src = image.image_url;
      featured.dataset.widths =
        '[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]';
      featured.dataset.aspectratio = image.image_aspect_ratio;
      featured.dataset.srcset = srcset;
      featured.classList.add('pt-featured-image');

      // append image tag to div
      div.appendChild(featured);
      //div.setAttribute('data-loaded', 'true');

      // add to featured list
      allFeaturedImagesFound.push(div);

      // create external div
      var div = document.createElement('div');
      div.className = 'pt-thumbnail-image-container';
      div.dataset.colour = variantTitle;

      // create thumbnail img
      var thumbnail = new Image();
      thumbnail.src = image.image_src;
      thumbnail.alt = image.image_alt;
      thumbnail.dataset.src = image.image_url;
      thumbnail.dataset.sizes = 'auto';
      thumbnail.dataset.widths =
        '[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]';
      thumbnail.dataset.aspectratio = image.image_aspect_ratio;
      featured.dataset.srcset = srcset;
      thumbnail.classList.add('pt-thumbnail-image');

      // append img tag to div
      div.appendChild(thumbnail);

      // add to featured list
      allThumbnailImagesFound.push(div);
    });
  }

  function populateHTMLImages() {
    // re-order images so they go in numerical order
    sortAlphaNumAsc(allFeaturedImagesFound);
    sortAlphaNumAsc(allThumbnailImagesFound);

    $('.pt-featured-images-inner').html(allFeaturedImagesFound);
    $('.pt-thumbnail-images-inner').html(allThumbnailImagesFound);

    // Call Slider
    initSliders();

    sliderInit = false;
  }

  function sortAlphaNumAsc(arr) {
    // eslint-disable-next-line func-style
    var sortByTitle = (a, b) =>
      $(a)
        .data('colour')
        .localeCompare($(b).data('colour'), 'en', { numeric: true });
    return arr.sort(sortByTitle);
  }

  $('.product-template-new-navigation-list-item').on('click', function () {
    $(this)
      .siblings()
      .removeClass('product-template-new-navigation-list-item-active');
    $(this).addClass('product-template-new-navigation-list-item-active');
    if ($(this).hasClass('product-template-new-navigation-description')) {
      $('.product-description-order-outer').siblings().fadeOut();
      $('.product-description-order-outer').fadeIn();
    }
    if ($(this).hasClass('product-template-new-navigation-assembly')) {
      $('.product-assembly-order-outer').siblings().fadeOut();
      $('.product-assembly-order-outer').fadeIn();
    }
    if ($(this).hasClass('product-template-new-navigation-spec')) {
      $('.product-spec-order-outer').siblings().fadeOut();
      $('.product-spec-order-outer').fadeIn();
    }
    if ($(this).hasClass('product-template-new-navigation-reviews')) {
      $('.product-reviews-outer').siblings().fadeOut();
      $('.product-reviews-outer').fadeIn();
    }
  });
});

// Product Video
$(document).ready(function () {
  var video = $('.featured-video');
  var play = $('.featured-video-play-button');
  var pause = $('.featured-video-pause-button');
  var overlay = $('.featured-video-overlay-grey');

  $('.featured-video-play-button').on('click', function () {
    playVideo();
  });

  function playVideo() {
    $(play).hide();
    $(overlay).hide();
    $(video).trigger('play');
    $(video).prop('volume', 0.5);
    $(video).attr('controls', 'true');
  }
});
